import React from 'react';
import Head from 'next/head';
import { facebookAppIdKBB, titleKbb, kbbUrl, sameAs, logoKbb } from '../constants';

export const renderSchemas = () => (
    <>
        <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{
                __html: JSON.stringify({
                    '@context': 'http://schema.org',
                    '@type': 'Organization',
                    url: kbbUrl,
                    legalName: titleKbb,
                    alternateName: 'KBB',
                    logo: logoKbb,
                    sameAs,
                }, undefined, 2),
            }}
        />

        <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{
                __html: JSON.stringify({
                    '@context': 'http://schema.org',
                    '@type': 'WebSite',
                    name: titleKbb,
                    alternateName: 'KBB',
                    url: kbbUrl,
                }, undefined, 2),
            }}
        />
    </>
);

function FacebookMetaTags() {
    return (
        <Head>
            <meta
                property="fb:app_id"
                content={facebookAppIdKBB}
            />
            {renderSchemas()}
        </Head>
    );
}

export default FacebookMetaTags;
